import { Tab } from "@mui/material";
import { MprcContainer } from "components";
import { MprcChipTabs } from "components/MprcChipTabs";
import { TrainingPanelAnalyseDimension } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";

interface IProps {
    selectedOption: TrainingPanelAnalyseDimension;
    onChange: (option: TrainingPanelAnalyseDimension) => void;
}

export const ChooseTrainingDimension = ({ selectedOption, onChange }: IProps) => {
    const { t } = useTranslation("dashboard");

    return <MprcContainer>
        <MprcChipTabs variant="scrollable" size="small" upperCase={false} value={selectedOption} onChange={(e, value) => onChange(value)} >
            <Tab label={t("TrainingPanel.Analysis.Dimension.Trainings")} value={TrainingPanelAnalyseDimension.Trainings} />
            <Tab label={t("TrainingPanel.Analysis.Dimension.ApprovalRate")} value={TrainingPanelAnalyseDimension.ApprovalRate} />
            <Tab label={t("TrainingPanel.Analysis.Dimension.CancelationRate")} value={TrainingPanelAnalyseDimension.CancelationRate} />
            <Tab label={t("TrainingPanel.Analysis.Dimension.OpinionRate")} value={TrainingPanelAnalyseDimension.OpinionRate} />
            <Tab label={t("TrainingPanel.Analysis.Dimension.Likes")} value={TrainingPanelAnalyseDimension.Likes} />
        </MprcChipTabs>
    </MprcContainer>;
};
